import React from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Chart from 'chart.js/auto';
import {Pie} from 'react-chartjs-2';
import {Dropdown, Button} from 'react-bootstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faFilter} from '@fortawesome/free-solid-svg-icons';
import "./InfoGlobalGraph.css"

/**
 *  InfoGlobalBase
 * @return {JSX}
 */
function InfoGlobalGraphView(props) {

  const data = {
    labels: props.names,
    datasets: [
      {
        data: props.sums,
        backgroundColor: props.colors,
        total: props.total, // add total property
      },
    ],
  };
  
  const dataEmploye = {
    labels: props.users,
    datasets: [
      {
        data: props.sumUser,
      },
    ],
  };
  
  const options = {
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: function(context) {
            const hasHour = Math.floor(context.parsed / 60) === 0;
            const totalheure = hasHour ? '' : Math.floor(context.parsed / 60) + 'h';
            const TotalMinute = hasHour ? String(context.parsed % 60).padStart(2, '0') + 'min' : String(context.parsed % 60).padStart(2, '0');
            return (
              context.label +
              ': ' + totalheure+
                TotalMinute +
              ' (' +
              ((context.parsed / context.dataset.total) * 100).toFixed(2) +
              '%)'
            );
          },
          aspectRatio: 1, // set the aspect ratio
          maintainAspectRatio: false,
        },
      },
    },
  };
  
  const legendData = data.datasets[0].data ?
  data.datasets[0].data.map((value, index) => {
    const minutesTotal = data.datasets[0].data[index];
    const hours = Math.floor(minutesTotal / 60);
    const minutes = Math.round(minutesTotal % 60).toString().padStart(2, '0');
  
    return (
      <tr key={index}>
        <td>
          <span
            style={{
              display: 'inline-block',
              width: '20px',
              height: '20px',
              backgroundColor: data.datasets[0].backgroundColor[index],
              marginRight: '5px',
            }}
          ></span>
          {data.labels[index] }
        </td>
        <td> : {((value / data.datasets[0].total) * 100).toFixed(2)}% {hours === 0 ? minutes + 'min' : hours + 'h' + minutes}</td>
      </tr>
    );
  }) :
  null;
  
  
  const legendDataEmploye = dataEmploye.datasets[0].data ?
  dataEmploye.datasets[0].data.map((value, index) => {
    const minutesTotal = dataEmploye.datasets[0].data[index];
    const hours = Math.floor(minutesTotal / 60);
    const minutes = Math.round(minutesTotal % 60).toString().padStart(2, '0');
  
    return (
      <tr key={index}>
        <td>
          {dataEmploye.labels[index].name }
        </td>
        <td> : {hours === 0 ? minutes + 'min' : hours + 'h' + minutes}</td>
      </tr>
    );
  }) :
  null;



  return (
    <React.Fragment>
    <FormControl>
      <FormLabel style={{color:"black", fontSize:"22px", display:"flex", justifyContent:"center"}} id="demo-row-radio-buttons-group-label">Période de temps</FormLabel>
      <RadioGroup
        row
        aria-labelledby="demo-row-radio-buttons-group-label"
        name="row-radio-buttons-group"
        defaultValue="1"
      >
        <FormControlLabel onChange={props.handlePeriodOfTime} style={{color:"black"}} value="1" control={<Radio />} label="1 semaine" />
        <FormControlLabel onChange={props.handlePeriodOfTime} style={{color:"black"}} value="2" control={<Radio />} label="1 mois" />
        <FormControlLabel onChange={props.handlePeriodOfTime} style={{color:"black"}} value="3" control={<Radio />} label="6 mois" />
        <FormControlLabel onChange={props.handlePeriodOfTime} style={{color:"black"}} value="4" control={<Radio />} label="1 an" />
      
      </RadioGroup>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom:"10px" }}>
      <Dropdown >
              <Dropdown.Toggle
                className="histoglobal-form-control"
                style={{
                  backgroundColor: 'white',
                  marginTop: '0px',
                  marginLeft: '0px',
                  color: 'black',
                  height: '47px',
                  border: '2px solid black',
                }}>
                {props.selectedEmploye.label}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {props.employers.map((user, index) => {
                  return <Dropdown.Item key={index} onClick={() => props.handleChangeEmployer(user)}>{user.label}</Dropdown.Item>;
                })}
              </Dropdown.Menu>
            </Dropdown>
            <Button onClick={() => props.filtrer()} style={{marginTop: '-11px',height:"47px", backgroundColor: 'black',marginLeft:"10px", color: 'white'}}>Filtrer <FontAwesomeIcon style={{marginLeft: '8px', marginBottom: '3px'}}
        icon={faFilter} /></Button>
        </div>
    </FormControl>

    <div>
    <div className="chantierinfograph-chart-container">
      <Pie data={data} options={options} />
    </div>
    <div className='chantierinfograph-textcenter'>
      <div >Total: {Math.floor(props.total / 60)}h{String(props.total % 60).padStart(2, '0')}</div>
    </div>
    <div style={{display: 'block'}}>
      <div className='chantierinfograph-textcenter'>
        <table >
          <tbody>{legendData}</tbody>
        </table>
      </div>
    </div>
    <div style={{display: 'block'}}>
      <div className='chantierinfograph-textcenter'>
        <table>
          <tbody>{legendDataEmploye}</tbody>
        </table>
      </div>
    </div>
  </div>
    
    </React.Fragment>
  );
}

export default InfoGlobalGraphView;




